import Layout from '../../layout/default';
import DataTable from  '../../components/DataTable/DataTable';
import { useEffect, useState, useRef } from "react";
import { Link, Route, Routes} from 'react-router-dom'
import { Navigate } from "react-router-dom";
import { MediaGroup, Media, MediaText, Image, Icon, CustomDropdownToggle, CustomDropdownMenu, LinkList, LinkListItem, Rating } from "../../components";
import { Dropdown, Button } from "react-bootstrap";
import Spinner from 'react-bootstrap/Spinner';
import { Breadcrumb } from 'react-bootstrap';
import { Modal, Row, Col, Form} from 'react-bootstrap'
import { Block, DatePicker, TimePicker } from '../../components';
import Select from '../../components/Form/Select';
import AddEditStaff from './AddEditStaff';
import { useApiClient } from '../../ApiService/useApiClient';

const baseURL = "HMCareStaff/stafflist/";

export const tableColumns = [    
    {
      name: "name",
      selector: (row) => row.name,
      sortable: true,
      cell: (row) => (
        <MediaGroup>            
            <MediaText>
                <Link to={`/staff/${row.agentId}`} className="title">{row.name}</Link>
            </MediaText>
        </MediaGroup>
        ),
    },
    {
        name: "Phone",
        selector: (row) => row.mobileNo,
        sortable: true,
      },
    {
      name: "Email",
      selector: (row) => row.emailId,
      sortable: true,
      hide: "md",
    },   
    {
      name: "action",      
      cell: (row) => (
        <div className="text-end w-100">
        <Dropdown>
            <Dropdown.Toggle size="sm" as={CustomDropdownToggle} className="btn btn-sm btn-icon btn-zoom me-n1">
                <Icon name="more-v"></Icon>
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu-sm" as={CustomDropdownMenu} align="end">
                <div className="dropdown-content py-1">
                    <LinkList className="link-list-hover-bg-primary link-list-md">                                                
                        <LinkListItem to={`/staff/${row.agentId}`}>
                            <Icon name="edit"></Icon><span>Details</span>
                        </LinkListItem>                                               
                    </LinkList>
                </div>
            </Dropdown.Menu>
        </Dropdown>
    </div>
      ),
      sortable: false,      
  },
    
];

// expanded component in mobile view
const expandedComponent = ({ data }) => {
    return (
      <ul className="data-details p-3 gap gy-1 border-bottom small">
        <li>
          <span className="data-title text-base fw-medium me-2">Name:</span> 
          <span className="data-text text-light">{data.name}</span>
        </li>
        <li>
          <span className="data-title text-base fw-medium me-2">Phone:</span> 
          <span className="data-text text-light">{data.mobileNo}</span>
        </li>
        <li>
          <span className="data-title text-base fw-medium me-2">Email:</span> 
          <span className="data-text text-light">{data.emailId}</span>
        </li>       
      </ul>
    );
};

const StaffList = () => {
  
    const api = useApiClient();
    const[data, setdata] = useState(null);  
    const[error, setError] = useState(null); 
    const dataFetchedRef = useRef(false);
    const[showAddEdit, setShowAddEdit] = useState(false);
    
    useEffect(()=>{
        
      if (dataFetchedRef.current) return;
      dataFetchedRef.current = true;
    
        api.get(baseURL)        
          .then((Response)=>{
              setdata(Response.data);

              var RawObj = Response.data;
              const RawObj2 = RawObj.filter((a) => a.isAdmin !== "1")
              setdata(RawObj2);                

          }).catch(error => {
              setError(error);     
              //console.log({error})
          });
        }, []);
  
      

      if (error) 
      {      
        if(error.message.indexOf("status code 401")){
          return <Navigate to="/auths/auth-login" />
        } else
        return "Error: ${error.message}";
      }
  
      if(!data) return (
        <Layout title="Staff" content="container"><Spinner animation="border" variant="primary" /></Layout>
        );;


        function openAddModal(){
          setShowAddEdit(true) ;       
      }

 return (
    <>
    <Layout title="Staff" content="container"> 
    
    <Breadcrumb className="breadcrumb-arrow">
      <Breadcrumb.Item><Link to={`/`}>Dashboard</Link></Breadcrumb.Item>      
      <Breadcrumb.Item active>Staff List</Breadcrumb.Item>
    </Breadcrumb>
   
    <Block.Head>
            <Block.HeadBetween className="align-items-start">
                <Block.HeadContent>
                    <div className="d-flex flex-column flex-md-row align-items-md-center">                     
                        
                        <div className="mt-3 mt-md-0 ms-md-3">
                            <h3 className="title mb-1">Staff Management</h3>
                            <span className="small">Manage staff records in the system. Add new staff records or modify existing staff records</span>
                        </div>
                        
                    </div>
                </Block.HeadContent> 
                <Block.HeadContent tools>
                            <div className="d-flex gap g-3 justify-content-center">
                                {/* <div>
                                    <Button variant="primary" action="add" onClick={openAddModal}>
                                        <Icon name="user"></Icon><span>Change Client</span>
                                    </Button>
                                </div> */}
                                <div>
                                    <Button variant="primary" action="add" onClick={openAddModal}>
                                        <Icon name="plus"></Icon><span>New User</span>
                                    </Button>
                                </div>
                            </div>
                        </Block.HeadContent>       
                 
            </Block.HeadBetween>
    </Block.Head>

    
    <DataTable tableClassName="data-table-head-light table-responsive" data={data} columns={tableColumns} expandableRowDisabled={true} filterFieldName="name" expandedComponent={expandedComponent} actions/>      
    </Layout>


   {showAddEdit && <AddEditStaff show={showAddEdit} setShowAddEdit={setShowAddEdit} isAdmin={"0"} data={data} setdata={setdata}/>}


{/* {false && <Modal show={formModal.opened} onHide={closeFormModal} size="lg">
<Form ref={modalForm} onSubmit={handleFormSubmit}>
    <Modal.Header closeButton>
    <Modal.Title className="event-title" as="h4">{formModal.modalTitle}</Modal.Title>
    </Modal.Header>                
    <Modal.Body>

        {false && <Spinner animation="border" variant="primary" />}             

        {<Row className="g-gs">
            <Col xs="6">
                <Form.Group>
                    <Form.Label htmlFor="eventTitle">First Name</Form.Label>
                    <div className="form-control-wrap">
                        <Form.Control id="AgentFname" type="text" defaultValue={formModal.AgentFname} placeholder="First Name(s)" />
                    </div>
                </Form.Group>
            </Col>
            <Col xs="6">
                <Form.Group>
                    <Form.Label htmlFor="eventTitle">Last Name</Form.Label>
                    <div className="form-control-wrap">
                        <Form.Control id="AgentLname" type="text" defaultValue={formModal.AgentLname} placeholder="Surname" />
                    </div>
                </Form.Group>
            </Col>
            <Col xs="6">
                <Form.Group>
                    <Form.Label htmlFor="eventTitle">Email Address</Form.Label>
                    <div className="form-control-wrap">
                        <Form.Control id="EmailId" type="text" defaultValue={formModal.EmailId} placeholder="Email Address" />
                    </div>
                </Form.Group>
            </Col>
            <Col xs="6">
                <Form.Group>
                    <Form.Label htmlFor="eventTitle">Password</Form.Label>
                    <div className="form-control-wrap">
                        <Form.Control id="Password" type="text" defaultValue={formModal.EmailId} placeholder="Password" />
                    </div>
                </Form.Group>
            </Col>
            <Col xs="6">
                <Form.Group>
                    <Form.Label htmlFor="eventTitle">Mobile Number</Form.Label>
                    <div className="form-control-wrap">
                        <Form.Control id="MobileNo" type="text" defaultValue={formModal.MobileNo} placeholder="Mobile" />
                    </div>
                </Form.Group>
            </Col>
            
        </Row>}
    </Modal.Body>
    <Modal.Footer>                    
        <Button variant="danger" onClick={closeFormModal}>Discard</Button>
        {formModal.action === 'add' && <Button variant="primary" type="submit" onClick={handleAddEvent}>Add User</Button>}
        {formModal.action === 'edit' && <Button variant="primary" type="submit" onClick={handleEditEvent}>Update User</Button>}
    </Modal.Footer>
</Form>
</Modal>} */}
</>                            


  )
}

export default StaffList